import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, filter, map } from 'rxjs';

import { CoreModuleName } from '@app/core/models/core-constant.model';
import { EidosConfigService } from '@common/config/eidos-config.service';
import { IEidosModuleConfiguration } from '@common/config/environment.interface';
import { DynamicApiResponse } from '@common/models/dynamic-api-response.model';
import { CoreFormatService } from '@common/services/core-format.service';
import { EidosBaseApiService } from '@common/services/eidos-base-api.service';
import { EidosLogService } from '@common/services/eidos-log.service';
import { EidosSecurityService } from '@common/services/eidos-security.service';

import { IReservationModuleAPIConfiguration } from '@app/res-common/models/rescom.model';
import { IResApiAddVillaOptionParams, ResBkgVillaOption, ResBkgVillaService } from '../models/res-booking.model';

@Injectable({
  providedIn: 'root'
})
export class ReservationVillaApiService extends EidosBaseApiService {

  constructor(
    public configService: EidosConfigService,
    public eidosSecurityService: EidosSecurityService,
    public http: HttpClient,
    public eidosLogService: EidosLogService,
    public domSanitizer: DomSanitizer,
    public coreFormatService: CoreFormatService
  ) {
    super(coreFormatService, configService, eidosLogService, eidosSecurityService, http);
    this.configService.currentModulesConfig
      .pipe(
        filter(
          (modules: Array<IEidosModuleConfiguration>) => !!modules.find((module) => module.moduleName === CoreModuleName.Reservation)
        )
      )
      .subscribe((modules) => {
        const module = modules.find((module) => module.moduleName === CoreModuleName.Reservation);
        if (module) {
          const reservationModuleAPI = module.API as IReservationModuleAPIConfiguration;
          this.urlAPI = reservationModuleAPI.url;
          this.staticUrlAPI = reservationModuleAPI.staticUrl;
          this.pluginUrlAPI = reservationModuleAPI.pluginUrl;
          this.apiVersion = reservationModuleAPI.version;
          if (reservationModuleAPI.headers) {
            this.headers = {
              ...reservationModuleAPI.headers,
              ...this.headers
            };
          }
        }
      });
  }

  addBkgVillaOption(params: IResApiAddVillaOptionParams) {
    return this.postDynamicAPI('property/addOptions', params).pipe(
      map<DynamicApiResponse, any>((response) => {
        return response.body;
      })
    )
  }

  getBkgVillaOption(bkgID: number, serviceID: number): Observable<ResBkgVillaOption[]> {
    return this.callDynamicAPI('property/getOptions', { BkgID: bkgID, ServiceID: serviceID }).pipe(
      map<DynamicApiResponse, ResBkgVillaOption[]>((response) => {
        return response.body.map((data: any) => new ResBkgVillaOption(data))
      })
    )
  }

  getBkgVillaService(bkgID: number): Observable<ResBkgVillaService[]> {
    return this.callDynamicAPI('property/getServices', { BkgID: bkgID }).pipe(
      map<DynamicApiResponse, ResBkgVillaService[]>((response) => {
        return response.body.map((data: any) => new ResBkgVillaService(data))
      })
    )
  }
}
